module.exports = {
  solve: function (iframeDoc, jsCode, bodyContent) {
    return '%main-solver%';
  },
  getTestCases: function () {
    const functionName = 'bugFixFinal';
    const params = {
      0: [
        'string',
        'xxbugYYX',
        'bug',
        'xxbugXbugbugYYy',
        'bugXYYbugxX',
        'xxxYYYzbugzyx',
      ],
    };
    const correct = [
      'xxflowerYYX',
      'flower',
      'xxflowerXflowerflowerYYy',
      'flowerXYYflowerxX',
      'xxxYYYzflowerzyx',
    ];
    const expectedType = ['string'];

    return {
      type: 'cases',
      payload: { functionName, params, correct, expectedType, output: true },
    };
  },
};
